import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IChat } from "../../types/IChat";
import { IChatMessage } from "../../types/IChatMessage";
import { ChatApi } from "../api/ChatApi";
import IChatUser from "../../types/IChatUser";
import { ChatVisibility } from "../../types/ChatVisibility";
import { IChatConfig } from "../../types/IChatConfig";
import { IUserProfile } from "../../types/IUserProfile";
import { NotificationLog } from "../../types/NotificationLog";


const ChatSlice = createSlice({
  name: "chat",
  initialState: {
    notifications: [] as NotificationLog[],
    requests: [] as IChat[],
    //messages: [] as IChatMessage[],
    usersOnline: [] as IChatUser[],
    connectionStatus: "" as string,
    unreadChats: 0,
    requestingChat: false,
    config: {} as IChatConfig,
    chatAvailable: false,
    profile: {} as IUserProfile,
  },
  reducers: {
    SetAvailable: (state, action: PayloadAction<boolean>) => {
      state.chatAvailable = action.payload;
    },
    SetUsersOnline: (state, action: PayloadAction<IChatUser[]>) => {
      state.usersOnline = action.payload;
    },
    SetConnectionStatus: (state, action) => {
      state.connectionStatus = action.payload;
    },
    SetRequests: (state, action) => {
      //Only set
      state.requests = action.payload
    },
    SetNotifications: (state, action) => {
      state.notifications = action.payload
    },
    SetChats: (state, action) => {

    },
    SetMessages: (state, action: PayloadAction<IChatMessage[]>) => {
      //console.log('SetMessages', action.payload?.length)
      if (!action.payload?.length)
        return;


    },
    PostMessage: (state, action: PayloadAction<IChatMessage>) => {
      //Adds a new message to the chat
      console.log('PostMessage');
      //AddMessage(action.payload);
    },
    DisconnectUser: (state, action: PayloadAction<IChatUser>) => {
      //Signal R Server event handled by Middleware
      console.log('DisconnectUser');
    },
    ChatStarted: (state, action: PayloadAction<IChat>) => {
      //Signal R Server event handled by Middleware
      console.log('ChatStarted');
    },
    MarkAsRead: (state, action: PayloadAction<{ conversationId: string, contactId: number, unRead: boolean }>) => {
      console.log('MarkAsRead');
    },
    ToggleChat: (state, action: PayloadAction<{ conversationId: string, uId: string, expanded: boolean }>) => {
      console.log('ToggleChat');
    },
    AddMessage: (state, action: PayloadAction<IChatMessage>) => {
      //Set the last message if this is a Chat rwquest
      var currentRequest = state.requests.find(c => c.ConversationId === action.payload.ConversationId);
      if (!currentRequest)
        return;

      currentRequest.Last_Message = action.payload.Text;
      currentRequest.Last_Message_Contact_Id = action.payload.Contact_Id;
      currentRequest.Last_Message_Date = action.payload.Created;

    },
    StartConnecting: (state, action) => {
      console.log('StartConnecting');
    },
    TypingMessage: (state, action: PayloadAction<IChat>) => {
      //Adds a new message to the chat
      console.log('TypingMessage');
    },
    RequestChat: (state, action: PayloadAction<string>) => {
      //Signal R Server event handled by Middleware
      console.log('RequestChat');
      state.requestingChat = true;
    },
    StaffJoined: (state, action: PayloadAction<IChat>) => {
      //Signal R Server event handled by Middleware
      console.log('StaffJoined');
    },
    LeaveChat: (state, action: PayloadAction<IChat>) => {
      //Signal R Server event handled by Middleware
      console.log('LeaveChat');
    },
    CloseChat: (state, action: PayloadAction<IChat>) => {
      //Signal R Server event handled by Middleware
      console.log('CloseChat');
    },
    ClearTyping: (state, action: PayloadAction<string>) => {
      console.log('ClearTyping');
      //state.messages = [...state.messages.filter(m => !m.Is_Typing)] as IChatMessage[]
    },
    SetRequesting: (state, action) => {
      state.requestingChat = action.payload;
    },
    SetVisibility: (state, action: PayloadAction<ChatVisibility>) => {
      console.log('SetVisibility', action.payload);
      //remove chat requests when goign offline
      if (action.payload !== ChatVisibility.Internal_External)
        state.requests = [];

    },
    PlayNewMessageSound: (state, action) => {
      var audio = new Audio('audio_file.mp3'); audio.play();
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      //Populate the chats in Redux state from the API
      ChatApi.endpoints.getConfig.matchFulfilled, (state, { payload }) => {
        console.log("ChatApi.endpoints.getConfig.matchFulfilled", payload);

        //Merge with existing chats
        state.config = payload
      }
    );
    builder.addMatcher(
      //Populate the chats in Redux state from the API
      ChatApi.endpoints.getChats.matchFulfilled,
      (state, { payload }) => {
        //console.log("ChatApi.endpoints.getChats.matchFulfilled", payload);

        //Merge with existing chats
        //state.chats = payload.concat(state.chats?.filter(c => !payload?.find(a => a?.ConversationId === c?.ConversationId)));
      }
    );
    builder.addMatcher(
      //Populate the userProfile in Redux state from the API
      ChatApi.endpoints.getProfile.matchFulfilled, (state, { payload }) => {
        state.profile = payload;
        console.log("ChatApi.endpoints.getProfile.matchFulfilled", payload);
      }
    );
    builder.addMatcher(
      //Populate the chat requests in Redux state from the API
      ChatApi.endpoints.getChatForUser.matchFulfilled,
      (state, { payload }) => {
        console.log("ChatApi.endpoints.getChatForUser.matchFulfilled", payload);

        //Merge with existing chats
        //if (payload)
        //  state.chats = [payload].concat(state.chats?.filter(c => payload?.ConversationId !== c?.ConversationId));
      }
    );
  },
});

export const { ToggleChat, SetNotifications, SetAvailable, ChatStarted, SetVisibility, DisconnectUser, SetUsersOnline, SetChats, PostMessage, AddMessage, StartConnecting, SetMessages, TypingMessage, ClearTyping, MarkAsRead, RequestChat, SetConnectionStatus, StaffJoined, LeaveChat, CloseChat, SetRequesting, SetRequests } = ChatSlice.actions
export default ChatSlice
